import { render } from "./InitialDisclosureDashboard.vue?vue&type=template&id=79e2c60a&scoped=true"
import script from "./InitialDisclosureDashboard.vue?vue&type=script&lang=js"
export * from "./InitialDisclosureDashboard.vue?vue&type=script&lang=js"

import "./InitialDisclosureDashboard.vue?vue&type=style&index=0&id=79e2c60a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79e2c60a"]])

export default __exports__